import type { JsonSchemaNode } from "@nmblr-platform-flow/schema";
import { humanize } from "../../../lib/humanize.js";

interface Props {
	name: string;
	schema: JsonSchemaNode;
	value: unknown;
	onChange: (value: unknown) => void;
	required?: boolean;
}

export function SelectInput({ name, schema, value, onChange, required }: Props) {
	const id = `field-${name}`;
	const options = (schema.enum ?? []).map(String);
	const current = typeof value === "string" ? value : String(schema.default ?? options[0] ?? "");
	return (
		<label className="mb-3 block" htmlFor={id}>
			<span className="text-xs text-text-muted">
				{humanize(name)}
				{required && <span className="ml-1 text-error">*</span>}
			</span>
			<select
				id={id}
				value={current}
				onChange={(e) => onChange(e.target.value)}
				className="mt-1 block w-full rounded-xl border border-border bg-canvas px-3 py-2 text-xs text-text-primary focus:border-accent focus:ring-1 focus:ring-accent focus:outline-none"
			>
				{options.length === 0 && (
					<option value="" disabled>
						-- select --
					</option>
				)}
				{options.map((opt) => (
					<option key={opt} value={opt}>
						{opt}
					</option>
				))}
			</select>
			{schema.description && (
				<span className="mt-1 block text-xs text-text-muted">{schema.description}</span>
			)}
		</label>
	);
}
